"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/NIFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_171)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_171`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V23.9998H-6V0.000244141Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V8.00006H-6V0.000244141ZM-6 15.9999H30V23.9998H-6V15.9999Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9999 9.07831C10.3863 9.07831 9.07825 10.3863 9.07825 12C9.07825 13.6137 10.3863 14.9217 11.9999 14.9217C13.6135 14.9217 14.9216 13.6137 14.9216 12C14.9216 10.3863 13.6135 9.07831 11.9999 9.07831ZM11.9999 13.6696C11.0779 13.6696 10.3304 12.9221 10.3304 12C10.3304 11.0779 11.0779 10.3304 11.9999 10.3304C12.922 10.3304 13.6695 11.0779 13.6695 12C13.6695 12.9221 12.922 13.6696 11.9999 13.6696Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.4458 12.4174L12 12L10.5541 12.4174L10.0721 13.2522H13.9278L13.4458 12.4174Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 9.91315L11.0361 11.5826L12 12L12.964 11.5826L12 9.91315Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.5542 12.4174H13.4459L12.964 11.5826H11.0361L10.5542 12.4174Z",
					fill: "#6DA544"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_171`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as NIFlag };
